import { Theme, css } from '@emotion/react';

import { useTranslation } from 'next-i18next';

import { ChangeEvent, useEffect, useState } from 'react';
import { useQueryClient } from 'react-query';

import { useCloseOverlay } from '@stores/useOverlayStore';
import { FontSizes, Radius, Spacing } from 'chatie-design-system';

import { ParsedStorage } from '@utils/localStorage';
import { getSettingDate } from '@utils/misc';

import Modal, { ModalButton, ModalProps } from '../common/Modal';

const mockDatePickerModalCSS = (theme: Theme) => css`
  text-align: center;
  line-height: 1.3;

  h5 {
    margin-bottom: ${Spacing.medium}px;
  }

  input {
    height: 50px;
    width: 100%;
    margin-bottom: ${Spacing.medium}px;
    background-color: ${theme.var.white};
    color: ${theme.var.black};
  }

  > p {
    font-size: ${FontSizes.xsmall}px;
    white-space: pre-line;
    background-color: ${theme.colors.main50};
    color: ${theme.var.gray800};
    padding: ${Spacing.xsmall}px;
    border-radius: ${Radius.medium}px;
  }
  .qualification {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: ${Spacing.small}px;

    p {
      font-size: ${FontSizes.small}px;
      text-align: left;

      small {
        font-size: ${FontSizes.xsmall}px;
        color: ${theme.var.gray600};
        display: block;
      }
    }
  }
`;

const parsingDate = (date: Date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');

  const formattedDate = `${year}-${month}-${day}T${hours}:${minutes}`;

  return formattedDate;
};

const MockDatePickerModal = ({ ...props }: ModalProps) => {
  const { t } = useTranslation();

  const queryClient = useQueryClient();
  const closeOverlay = useCloseOverlay();

  const formattedDate = parsingDate(new Date());

  const [selectedDate, setSelectedDate] = useState(formattedDate);
  const [kstDate, setKstDate] = useState(new Date().toString());
  const [currentTime, setCurrentTime] = useState<
    string | Date | null | undefined
  >(null);

  useEffect(() => {
    const settingDate = getSettingDate()?.date;
    setCurrentTime(settingDate ?? new Date());
  }, []);

  const handleClickSetting = () => {
    ParsedStorage.setItem('mockDate', { date: kstDate });
    setCurrentTime(kstDate);
    queryClient.invalidateQueries();
  };

  const handleDateChange = (e: ChangeEvent<HTMLInputElement>) => {
    const selectedDate = e.target.value;

    const dateInKST = new Date(selectedDate).toString();
    const parsedDate = parsingDate(new Date(selectedDate));
    setKstDate(dateInKST);
    setSelectedDate(parsedDate);
  };

  return (
    <Modal {...props} title={t('개발 Date Picker')}>
      <div css={mockDatePickerModalCSS}>
        <input
          type="datetime-local"
          onChange={handleDateChange}
          value={selectedDate}
          max="2029-06-20T20:06"
          min="2016-02-20T02:20"
        />
        <p>
          <>지금 날짜 : {currentTime?.toString()}</>
        </p>
        <ModalButton
          onClick={() => {
            handleClickSetting();
            closeOverlay();
          }}
          text={t('설정')}
        />
      </div>
    </Modal>
  );
};

export default MockDatePickerModal;
